
// 添加锁机制，可以对某个 key 进行加锁
const lockerManager = {};

export default {
// 添加 locker
  addLocker(key) {
    if (lockerManager[getLockerKey(key)]) {
      return false;
    } else {
      lockerManager[getLockerKey(key)] = true;
      return true;
    }
  },

  // 获取 locker
  getLocker(key) {
    if (this.addLocker(key)) {
      return false;
    } else {
      return true;
    }
  },

  // 释放 locker
  releaseLocker(key) {
    lockerManager[getLockerKey(key)] = false;
    delete lockerManager[getLockerKey(key)];
  }

};

function getLockerKey(key) {
  return 'locker:' + key;
}



// WEBPACK FOOTER //
// ./src/util/locker.js